import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Tecnico } from './entity-tecnicos.model';

@Injectable({
  providedIn: 'root'
})
export class TecnicosService {
  url: string;

  constructor(private http: HttpClient) {}

  getTecnicos(): Observable<Tecnico[]> {
    return this.http.get<Tecnico[]>(`${this.url}/tecnicos/`);
  }
}
